<template>
  <span>
    <home-hero></home-hero>
  </span>
</template>

<script>
import HomeHero from '@/components/HomeHero.vue';

export default {
  name: 'home',
  components: {
    HomeHero,
  },
};
</script>
